import { ComponentRendering, ImageField, NextImage } from '@sitecore-jss/sitecore-jss-nextjs';
import useHelpers from 'hooks/helpers';

interface ImageProps {
  fields: {
    image: ImageField;
  };
  rendering: ComponentRendering;
  articleBody?: boolean;
}

const Image = ({ fields, rendering, articleBody = false }: ImageProps): JSX.Element => {
  const { anchorId } = useHelpers(rendering);
  return (
    <div className={`position-relative h-100 ${articleBody ? 'article-body-image' : ''}`}>
      <NextImage id={anchorId} field={fields.image} fill />
    </div>
  );
};

export default Image;
